"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedthunderstormsm = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedthunderstormsm` : '') + (description ? ` desc-brandedthunderstormsm` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedthunderstormsm"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedthunderstormsm"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.57 8.72h3.12l-3.12 5.01h2.81L11.14 20l2.18-5.01h-1.87l3.12-6.27Z",
    fill: "#F7B941"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.49 14.44a1.12 1.12 0 0 1-2.02-.95c.26-.56 2.42-2.58 2.42-2.58s-.14 2.97-.4 3.53Z",
    fill: "#8AE6EB"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.52 15.7a1.12 1.12 0 0 1-2.02-.95c.26-.57 2.42-2.58 2.42-2.58s-.14 2.96-.4 3.52Z",
    fill: "#8AE6EB"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.4 19.35a1.12 1.12 0 0 1-2.03-.94c.26-.57 2.42-2.58 2.42-2.58s-.14 2.96-.4 3.52Z",
    fill: "#8AE6EB"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.93 5.94c0-1.54-1.1-2.8-2.54-3.07a4.67 4.67 0 0 0-8.3-.63 3.58 3.58 0 0 0-5.53 1.91C1.77 3.7 0 4.93 0 6.57c0 1.65 1.72 2.85 3.53 2.41a2.8 2.8 0 0 0 4.56.3 4.98 4.98 0 0 0 8.84-.21c1.67-.07 3-1.44 3-3.12Z",
    fill: "#D4D4D4"
  }));
};
var _default = exports.default = brandedthunderstormsm;